import {
  TBusinessFormData,
  TCategoryFormData,
  TEmployeeFormData,
  TEventFormData,
  TGroupFormData,
  THistoryFormData,
  TMainVisualFormData,
  TMaterialsFormData,
  TNewsFormData,
  TNoticeFormData,
  TPartnerFormData,
  TPopupFormData,
  TRecruitFormData,
} from 'src/@types';
import {
  IBusiness,
  ICategory,
  IEmployee,
  IEvent,
  IGroup,
  IHistory,
  IMainVisual,
  IMaterials,
  INews,
  INotice,
  IPartner,
  IPopup,
  IRecruit,
} from 'src/models';
import {
  INIT_BUSINESS_FORM_DATA,
  INIT_CATEGORY_FORM_DATA,
  INIT_EMPLOYEE_FORM_DATA,
  INIT_EVENT_FORM_DATA,
  INIT_GROUP_FORM_DATA,
  INIT_HISTORY_FORM_DATA,
  INIT_MAIN_VISUAL_FORM_DATA,
  INIT_MATERIAL_FORM_DATA,
  INIT_NEWS_FORM_DATA,
  INIT_NOTICE_FORM_DATA,
  INIT_PARTNER_FORM_DATA,
  INIT_POPUP_FORM_DATA,
  INIT_RECRUIT_FORM_DATA,
} from 'src/static/constants';

// popup form에 초기값 생성하는 합수
export const getPopupFormDefaultValues = (popup?: IPopup): TPopupFormData => {
  return popup
    ? {
        title: popup.title || INIT_POPUP_FORM_DATA.title,
        desc: popup.desc || INIT_POPUP_FORM_DATA.desc,
        startDt: popup.startDt || INIT_POPUP_FORM_DATA.startDt,
        endDt: popup.endDt || INIT_POPUP_FORM_DATA.endDt,
        width: popup.width || INIT_POPUP_FORM_DATA.width,
        height: popup.height || INIT_POPUP_FORM_DATA.height,
        environment: popup.environment || INIT_POPUP_FORM_DATA.environment,
        displayHours: popup.displayHours || INIT_POPUP_FORM_DATA.displayHours,
        topPosition: popup.topPosition || INIT_POPUP_FORM_DATA.topPosition,
        leftPosition: popup.leftPosition || INIT_POPUP_FORM_DATA.leftPosition,
      }
    : INIT_POPUP_FORM_DATA;
};
// employee form에 초기값 생성하는 합수
export const getEmployeeFormDefaultValues = (employee?: IEmployee): TEmployeeFormData => {
  const selectedOprtrGroupList = employee?.oprtrGroupList?.map((item) => {
    return {
      label: item.oprtrGroupNm,
      value: item.oprtrGroupSid,
    };
  });
  return employee
    ? {
        oprtrSid: employee.oprtrSid || INIT_EMPLOYEE_FORM_DATA.oprtrSid,
        loginId: employee.loginId || INIT_EMPLOYEE_FORM_DATA.loginId,
        oprtrNm: employee.oprtrNm || INIT_EMPLOYEE_FORM_DATA.oprtrNm,
        oprtrGroupSid: employee.oprtrGroupSid || INIT_EMPLOYEE_FORM_DATA.oprtrGroupSid,
        oprtrGroupSidList: employee.oprtrGroupSidList || INIT_EMPLOYEE_FORM_DATA.oprtrGroupSidList,
        oprtrGroupList: selectedOprtrGroupList || INIT_EMPLOYEE_FORM_DATA.oprtrGroupList,
        oprtrSttsCd: employee.oprtrSttsCd?.code || INIT_EMPLOYEE_FORM_DATA.oprtrSttsCd,
        beforePwd: INIT_EMPLOYEE_FORM_DATA.beforePwd,
        pwd: INIT_EMPLOYEE_FORM_DATA.pwd,
        pwdCorrect: INIT_EMPLOYEE_FORM_DATA.pwdCorrect,
        regDt: employee.regDt || INIT_EMPLOYEE_FORM_DATA.regDt,
        updDt: employee.updDt || INIT_EMPLOYEE_FORM_DATA.updDt,
      }
    : INIT_EMPLOYEE_FORM_DATA;
};

// notice form에 초기값 생성하는 합수
export const getNoticeFormDefaultValues = (notice?: INotice): TNoticeFormData => {
  return notice
    ? {
        noticeSid: notice.noticeSid || INIT_NOTICE_FORM_DATA.noticeSid,
        prNotiCtgyCd: notice.prNotiCtgyCd || INIT_NOTICE_FORM_DATA.prNotiCtgyCd,
        title: notice.title || INIT_NOTICE_FORM_DATA.title,
        descript: notice.descript || INIT_NOTICE_FORM_DATA.descript,
        filePath: notice.filePath || INIT_NOTICE_FORM_DATA.filePath,
        deleteFilesPath: INIT_NOTICE_FORM_DATA.deleteFilesPath,
        regDt: notice.regDt || INIT_NOTICE_FORM_DATA.regDt,
        updDt: notice.updDt || INIT_NOTICE_FORM_DATA.updDt,
      }
    : INIT_NOTICE_FORM_DATA;
};
// news form에 초기값 생성하는 합수
export const getNewsFormDefaultValues = (news?: INews): TNewsFormData => {
  return news
    ? {
        newsSid: news.newsSid || INIT_NEWS_FORM_DATA.newsSid,
        prNewsCtgyCd: news.prNewsCtgyCd || INIT_NEWS_FORM_DATA.prNewsCtgyCd,
        source: news.source || INIT_NEWS_FORM_DATA.source,
        title: news.title || INIT_NEWS_FORM_DATA.title,
        link: news.link || INIT_NEWS_FORM_DATA.link,
        descript: news.descript || INIT_NEWS_FORM_DATA.descript,
        filePath: news.filePath || INIT_NEWS_FORM_DATA.filePath,
        files: INIT_NEWS_FORM_DATA.files,
        deleteFilesPath: INIT_NEWS_FORM_DATA.deleteFilesPath,
        regDt: news.regDt || INIT_NEWS_FORM_DATA.regDt,
        updDt: news.updDt || INIT_NEWS_FORM_DATA.updDt,
        originRegDt: news.originRegDt || INIT_NEWS_FORM_DATA.originRegDt,
      }
    : INIT_NEWS_FORM_DATA;
};
// recruit form에 초기값 생성하는 합수
export const getRecruitFormDefaultValues = (recruit?: IRecruit): TRecruitFormData => {
  return recruit
    ? {
        recruitSid: recruit.recruitSid || INIT_RECRUIT_FORM_DATA.recruitSid,
        expCd: recruit.expCd?.code || INIT_RECRUIT_FORM_DATA.expCd,
        applyFieldCd: recruit.applyFieldCd?.code || INIT_RECRUIT_FORM_DATA.applyFieldCd,
        veteranCd: recruit.veteranCd?.code || INIT_RECRUIT_FORM_DATA.veteranCd,
        disabledCd: recruit.disabledCd?.code || INIT_RECRUIT_FORM_DATA.disabledCd,
        nameKr: recruit.nameKr || INIT_RECRUIT_FORM_DATA.nameKr,
        nameEn: recruit.nameEn || INIT_RECRUIT_FORM_DATA.nameEn,
        desiredSalary: recruit.desiredSalary || INIT_RECRUIT_FORM_DATA.desiredSalary,
        genderTypeCd: recruit.genderTypeCd?.code || INIT_RECRUIT_FORM_DATA.genderTypeCd,
        email: recruit.email || INIT_RECRUIT_FORM_DATA.email,
        phone: recruit.phone || INIT_RECRUIT_FORM_DATA.phone,
        emergencyContact: recruit.emergencyContact || INIT_RECRUIT_FORM_DATA.emergencyContact,
        birthDate: recruit.birthDate || INIT_RECRUIT_FORM_DATA.birthDate,
        calendarTypeCd: recruit.calendarTypeCd?.code || INIT_RECRUIT_FORM_DATA.calendarTypeCd,
        applySrc: recruit.applySrc || INIT_RECRUIT_FORM_DATA.applySrc,
        address: recruit.address || INIT_RECRUIT_FORM_DATA.address,
        resumeFilePath: recruit.resumeFilePath || INIT_RECRUIT_FORM_DATA.resumeFilePath,
        applyDt: recruit.applyDt || INIT_RECRUIT_FORM_DATA.applyDt,
        recruitStatusCd: recruit.recruitStatusCd?.code || INIT_RECRUIT_FORM_DATA.recruitStatusCd,
        memo: recruit.memo || INIT_RECRUIT_FORM_DATA.memo,
      }
    : INIT_RECRUIT_FORM_DATA;
};

export const getGroupFormDefaultValues = (group?: IGroup): TGroupFormData => {
  return group
    ? {
        oprtrGroupSid: group.oprtrGroupSid || INIT_GROUP_FORM_DATA.oprtrGroupSid,
        oprtrGroupNm: group.oprtrGroupNm || INIT_GROUP_FORM_DATA.oprtrGroupNm,
        dscrpt: group.dscrpt || INIT_GROUP_FORM_DATA.dscrpt,
        useYn: group.useYn || INIT_GROUP_FORM_DATA.useYn,
        roleIdList: group.roleIdList || INIT_GROUP_FORM_DATA.roleIdList,
      }
    : INIT_GROUP_FORM_DATA;
};
// 메인 비주얼
export const getMainVisualFormDefaultValues = (mainVisual?: IMainVisual): TMainVisualFormData => {
  const parseHtmlToText = (html: string): string => {
    try {
      // 빈 문자열이나 null/undefined 처리
      if (!html) return '';

      // 특정 HTML 엔티티 처리
      const entities: { [key: string]: string } = {
        '&nbsp;': ' ',
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
      };

      // HTML 파싱
      const doc = new DOMParser().parseFromString(html, 'text/html');
      let text = doc.body.textContent || '';

      // HTML 엔티티 변환
      Object.entries(entities).forEach(([entity, char]) => {
        text = text.replace(new RegExp(entity, 'g'), char);
      });

      // 연속된 공백 제거 및 트림
      return text.replace(/\s+/g, ' ').trim();
    } catch (error) {
      console.error('HTML 파싱 에러:', error);
      return '';
    }
  };
  return mainVisual
    ? {
        visualSid: mainVisual.visualSid || INIT_MAIN_VISUAL_FORM_DATA.visualSid,
        files: [],
        deleteFilesPath: [],
        useYn: mainVisual.useYn || false,
        ordr: mainVisual.ordr || 0,
        lang: mainVisual.lang || '',
        mode: mainVisual.mode || 'data',
        mainText: {
          text: parseHtmlToText(mainVisual.mainText?.text || ''),
          color: mainVisual.mainText?.color || '#000',
        },
        subText: {
          text: parseHtmlToText(mainVisual.subText?.text || ''),
          color: mainVisual.subText?.color || '#000',
        },
        editorContent: mainVisual.editorContent || INIT_MAIN_VISUAL_FORM_DATA.editorContent,
      }
    : INIT_MAIN_VISUAL_FORM_DATA;
};
// 회사 연혁
export const getHistoryFormDefaultValues = (history?: IHistory): THistoryFormData => {
  return history
    ? {
        historyDate: history.historyDate || INIT_HISTORY_FORM_DATA.historyDate,
        titleKo: history.titleKo || INIT_HISTORY_FORM_DATA.titleKo,
        titleEn: history.titleEn || INIT_HISTORY_FORM_DATA.titleEn,
        desc: history.desc || INIT_HISTORY_FORM_DATA.desc,
      }
    : INIT_HISTORY_FORM_DATA;
};
// 회사 파트너
export const getPartnerFormDefaultValues = (partner?: IPartner): TPartnerFormData => {
  return partner
    ? {
        partnerSid: partner.partnerSid || INIT_PARTNER_FORM_DATA.partnerSid,
        partnerName: partner.partnerName || INIT_PARTNER_FORM_DATA.partnerName,
        logoImgPath: partner.logoImgPath || INIT_PARTNER_FORM_DATA.logoImgPath,
        file: INIT_PARTNER_FORM_DATA.file,
        useYn: partner.useYn || INIT_PARTNER_FORM_DATA.useYn,
        categoryType: partner.categoryType?.code || INIT_PARTNER_FORM_DATA.categoryType,
      }
    : INIT_PARTNER_FORM_DATA;
};
// 이벤트(스케줄)
export const getEventFormDefaultValues = (event?: IEvent): TEventFormData => {
  return event
    ? {
        eventTypeCd: event.eventTypeCd?.value || INIT_EVENT_FORM_DATA.eventTypeCd,
        startDt: event.startDt || INIT_EVENT_FORM_DATA.startDt,
        title: event.title || INIT_EVENT_FORM_DATA.title,
        location: event.location || INIT_EVENT_FORM_DATA.location,
        desc: event.desc || INIT_EVENT_FORM_DATA.desc,
      }
    : INIT_EVENT_FORM_DATA;
};
// 자료실
export const getMaterialsFormDefaultValues = (material?: IMaterials): TMaterialsFormData => {
  return material
    ? {
        type: material.type?.code || INIT_MATERIAL_FORM_DATA.type,
        title: material.title || INIT_MATERIAL_FORM_DATA.title,
        file: material.file || INIT_MATERIAL_FORM_DATA.file,
        useYn: material.useYn || INIT_MATERIAL_FORM_DATA.useYn,
        materialSid: material.materialSid || INIT_MATERIAL_FORM_DATA.materialSid,
      }
    : INIT_MATERIAL_FORM_DATA;
};
// 카테고리
export const getCategoryFormDefaultValues = (category?: ICategory): TCategoryFormData => {
  return category
    ? {
        useYn: category.useYn || INIT_CATEGORY_FORM_DATA.useYn,
        pCategory: category.pCategory || INIT_CATEGORY_FORM_DATA.pCategory,
        categoryNm: category.categoryNm || INIT_CATEGORY_FORM_DATA.categoryNm,
        mainTitle: category.mainTitle || INIT_CATEGORY_FORM_DATA.mainTitle,
        subTitle: category.subTitle || INIT_CATEGORY_FORM_DATA.subTitle,
        mainDesc: category.mainDesc || INIT_CATEGORY_FORM_DATA.mainDesc,
        subDesc: category.subDesc || INIT_CATEGORY_FORM_DATA.subDesc,
        pipeline: category.pipeline || INIT_CATEGORY_FORM_DATA.pipeline,
        pipelineList: category.pipelineList || INIT_CATEGORY_FORM_DATA.pipelineList,
      }
    : INIT_CATEGORY_FORM_DATA;
};
// 비즈니스
export const getBusinessFormDefaultValues = (business?: IBusiness): TBusinessFormData => {
  return business
    ? {
        bnCatCd: business.bnCatCd || INIT_BUSINESS_FORM_DATA.bnCatCd,
        bnSubCatCd: business.bnSubCatCd || INIT_BUSINESS_FORM_DATA.bnSubCatCd,
        pipelineCd: business.pipelineCd || INIT_BUSINESS_FORM_DATA.pipelineCd,
        useYn: business.useYn || INIT_BUSINESS_FORM_DATA.useYn,
        lang: business.lang || INIT_BUSINESS_FORM_DATA.lang,
        ordr: business.ordr || INIT_BUSINESS_FORM_DATA.ordr,
        title: business.title || INIT_BUSINESS_FORM_DATA.title,
        summary: business.summary || INIT_BUSINESS_FORM_DATA.summary,
        thumbPath: business.thumbPath || INIT_BUSINESS_FORM_DATA.thumbPath,
        detailPath: business.detailPath || INIT_BUSINESS_FORM_DATA.detailPath,
        descript: business.descript || INIT_BUSINESS_FORM_DATA.descript,
        subContentInfos: business.subContentInfos || INIT_BUSINESS_FORM_DATA.subContentInfos,
      }
    : INIT_BUSINESS_FORM_DATA;
};
